<div class="card mb-4">
  <div class="card-header">
    <b>{{ 'Attachments' | translate }}</b>
  </div>

  <div class="card-body pb-2">
    <app-attachment *ngFor="let attachment of attachments"
      [attachment]="attachment"
      [shareableId]="shareableId"
    ></app-attachment>
  </div>
</div>
